import React from 'react';

const Footer = () => {
    const sections = [
        { title: "Product", links: ["Features", "Pricing", "Documentation"] },
        { title: "Company", links: ["About", "Blog", "Careers"] },
        { title: "Legal", links: ["Privacy", "Terms", "Security"] }
    ];

    return (
        <footer className="bg-gray-900 text-white py-6">
            <div className="border-t border-gray-800  pt-8 text-center text-gray-400">
                    <p>&copy; 2025 <a href="https://www.mi-expert.com">MiExpert</a>. All rights reserved.</p>
                </div>
            {/* <div className="container mx-auto px-6">
                <div  className="flex flex-col md:flex-row justify-between">
                    <div className="mb-8 md:mb-0">
                        <h3 className="text-2xl font-bold mb-4">MiChat</h3>
                        <p className="text-gray-400">Developed by MiExpert Limited</p>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
                        {sections.map((section, index) => (
                            <div key={index}>
                                <h4 className="text-lg font-semibold mb-4">{section.title}</h4>
                                <ul className="space-y-2">
                                    {section.links.map((link, linkIndex) => (
                                        <li key={linkIndex}>
                                            <a href="#" className="text-gray-400 hover:text-white">
                                                {link}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
                
            </div> */}
        </footer>
    );
};

export default Footer;

export {};
